<div class="modern-accordion">
    @if (items.length === 0) {
    <div class="empty-state">
        <div class="empty-icon">
            <lucide-icon class="w-10 h-10 text-gray-300" [img]="CircleQuestionMark"></lucide-icon>
        </div>
        <p class="empty-text">No results found</p>
        <p class="empty-subtitle">Try adjusting your search terms</p>
    </div>
    } @for (item of items; track $index) {
    <div class="accordion-item" [class.is-open]="isOpen($index)">
        <button
            class="accordion-header"
            (click)="toggle($index)"
            [attr.aria-expanded]="isOpen($index)"
            [attr.aria-controls]="'accordion-content-' + $index"
        >
            <span class="accordion-title">{{ item.title }}</span>
            <div class="accordion-icon">
                <lucide-icon
                    class="w-5 h-5 transition-transform duration-200 text-primary"
                    [ngClass]="{ 'rotate-180': isOpen($index) }"
                    [img]="ChevronDown"
                ></lucide-icon>
            </div>
        </button>
        <div class="accordion-content-wrapper" [class.is-expanded]="isOpen($index)">
            <div class="accordion-content" [id]="'accordion-content-' + $index">
                <div class="content-inner" [innerHTML]="item.content"></div>
            </div>
        </div>
    </div>
    }
</div>
